const processInclude = require('app_storefront_base/util');

window.onjQueryLoad(function () {
    processInclude(require('plugin_catalog/product-detail/product-detail'));
    processInclude(require('plugin_wishlists/product/wishlist'));
}, true);
